// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
//import 'babel-polyfill';
import Vue from 'vue'
import VueCookie from 'vue-cookie'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import moment from 'moment'
import Toasted from 'vue-toasted'
import VueTinymce from 'vue-tinymce'
import VueTheMask from 'vue-the-mask'
import VueI18n from 'vue-i18n';

Vue.use(VueTinymce)
let Credenciamento = () => import(/* webpackChunkName: "credenciamento" */'./components/Credenciamento.vue')

let CertificadosMain = () => import(/* webpackChunkName: "certificado" */'./components/CertificadosMain.vue')
let CertificadoEditor = () => import(/* webpackChunkName: "certificado" */'./components/CertificadoEditor.vue')

let LoaderFullPage = () => import(/* webpackChunkName: "listaParticipantes" */'./components/listaparticipantes/LoaderFullPage.vue')
let ListaParticipantes = () => import(/* webpackChunkName: "listaParticipantes" */'./components/listaparticipantes/ListaParticipantes.vue')
let ListaDados = () => import(/* webpackChunkName: "listaParticipantes" */'./components/ListaDados.vue')
let VodalNovoParticipante = () => import(/* webpackChunkName: "listaParticipantes" */'./components/listaparticipantes/VodalNovoParticipante.vue')

let AnaisHeader = () => import(/* webpackChunkName: "anais" */'./components/anais/AnaisHeader.vue')
let AnaisMain = () => import(/* webpackChunkName: "anais" */'./components/anais/AnaisMain.vue')
let AnaisAutores = () => import(/* webpackChunkName: "anais" */'./components/anais/AnaisAutores.vue')
let AnaisAutor = () => import(/* webpackChunkName: "anais" */'./components/anais/AnaisAutor.vue')
let AnaisTrabalhos = () => import(/* webpackChunkName: "anais" */'./components/anais/AnaisTrabalhos.vue')
let AnaisTrabalho = () => import(/* webpackChunkName: "anais" */'./components/anais/AnaisTrabalho.vue')
let AnaisTrabalhoRow = () => import(/* webpackChunkName: "anais" */'./components/anais/AnaisTrabalhoRow.vue')

Vue.use(VueCookie);
Vue.config.productionTip = false

Vue.use(VueResource);
Vue.use(VueRouter);
Vue.use(Toasted);
Vue.use(VueI18n);

if(lang=="pt-br"){
  lang="pt_br";
}

const i18n = new VueI18n({
  locale: lang, // set locale
  fallbackLocale: 'pt_br',
  fallbackRoot: true,
  silentTranslationWarn: true,
})

Vue.config.lang = lang;

Vue.filter('upper', function (value) {
  return value.toUpperCase()
});

Vue.filter('plural', function(value, singular, plur) {
  return (value == 1 ? singular : plur)
});

Vue.filter('moment', function(date){
  return moment(date).format('DD/MM HH:mm');
});

window.moment = moment;

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('moeda', function(value){
  if(value == 0) return "Gratuito"
 return "R$ "+ parseFloat(value).toFixed(2).replace(".", ",");;
});

Vue.filter('moment', function(date){
  return moment(date*1000).format('DD/MM/YY');
});

Vue.filter('diaHora', function(date){
  return moment(date*1000).format('DD/MM/YY H:mm');
});

Vue.filter('mes', function(date){
 return moment(date*1000).format('MMM');
});

Vue.filter('ano', function(date){
  return moment(date*1000).format('YYYY');
});
Vue.filter('dia', function(date){
 return moment(date*1000).format('DD');
});

Vue.filter('tempo', function(date){
  return moment(date*1000).format('H:mm');
});

Vue.component('CertificadosMain', CertificadosMain);
Vue.component('CertificadoEditor', CertificadoEditor);
Vue.component('Credenciamento', Credenciamento);


// lista de participantes
// vue the mask é utilizado na lista de participantes
Vue.use(VueTheMask)
Vue.component('ListaParticipantes', ListaParticipantes);
Vue.component('LoaderFullPage', LoaderFullPage);
Vue.component('ListaDados', ListaDados);
Vue.component('VodalNovoParticipante', VodalNovoParticipante);
Vue.component('AnaisHeader', AnaisHeader);
Vue.component('AnaisTrabalhoRow', AnaisTrabalhoRow);

const routerCertificados = new VueRouter({
  routes: [
    { path: '/', component: CertificadosMain },
    { path: '/novo', component: CertificadoEditor },
    { path: '/:id', component: CertificadoEditor }
  ]
})

const routerAnais = new VueRouter({
  routes: [
    { path: '/autores/:pesquisa', component: AnaisAutores },
    { path: '/autores', component: AnaisAutores },
    { path: '/autor/:autor_id', component: AnaisAutor },
    { path: '/trabalhos/:pesquisa', component: AnaisTrabalhos, name: 'trabalhos' },
    { path: '/trabalhos', component: AnaisTrabalhos },
    { path: '/trabalho/:trabalho_id', component: AnaisTrabalho },
    { path: '/:page', component: AnaisMain },
    { path: '/', component: AnaisMain },
  ],
  scrollBehavior (to, from, savedPosition) { return { x: 0, y: 0 } },
})

let newVue = [
  // aqui temos um array
  // de objetos que vão na função
  // new Vue({...})
  {el: '#app'},
  {el: '#app-certificados', router: routerCertificados},
  {el: '#app-anais', router: routerAnais},
]

newVue.forEach(obj => new Vue({i18n, ...obj}))

window.Vue = Vue;



// WEBPACK FOOTER //
// ./src/main.js